module.exports = __webpack_public_path__ + "img/2012-12-14 18.18.17.9bce274a.jpg";